module.exports = __webpack_public_path__ + "static/media/social_twitter.478754ae.svg";